export default {
  None : 0,
  Promoted : 1,
  Viewed : 2,
  ChatStarted : 3,
  LikeOrDisLike : 4,
}
